import React from 'react';
import cl from './SubscriptionCancellationsBrowseEditor.module.css'
import AutoSizer from "react-virtualized-auto-sizer";
import {FixedSizeList} from "react-window";
import SubscriptionCancellationsBrowseEditorItem from "./SubscriptionCancellationsBrowseEditorItem";
import ServerManager from "../../API/ServerManager";

const SubscriptionCancellationsBrowseEditor = ({
                                                   filteredItems,
                                                   setFilteredItems,
                                                   rqIdCounter,
                                                   status,
                                                   setStatus,
                                                   pagination,
                                                   setPagination,
                                                   ITEMS_PER_RQ_PAGE,
                                                   dateFromText,
                                                   dateTillText,
                                               }) => {

    async function requestMoreItems() {
        const extraParams = {};

        if (dateFromText)
            extraParams.from = dateFromText;

        if (dateTillText)
            extraParams.to = dateTillText;

        rqIdCounter.current++;
        const rqId = rqIdCounter.current;
        //console.log("rqId", rqId);

        setStatus("addLoad")
        try {
            //await new Promise(resolve => setTimeout(resolve, 3500)); // temp!
            const data = await ServerManager.getSubscriptionCancellationsFilteredList(ITEMS_PER_RQ_PAGE, pagination.next_offset, extraParams);
            if (rqIdCounter.current === rqId) {
                setFilteredItems([...filteredItems, ...data.cancellations]);
                setPagination(data.pagination);
                setStatus("idle");
            }
        } catch (error) {
            if (rqIdCounter.current === rqId) {
                //setMainErrorMessage(`Ошибка при загрузке данных: ${error}`); // TODO popup?
                setStatus("idle");
            }
        } finally {
            if (rqIdCounter.current !== rqId) {
                //console.log("ignored! rqId", rqId);
            }
        }
    }

    return (
        <div className={cl.main}>
            {filteredItems.length > 0 && <div className={cl.itemList}>
                <MyList
                    filteredItems={filteredItems}
                    getListItemKey={getListItemKey}
                    renderListRow={renderListRow}
                    requestMoreItems={requestMoreItems}
                    pagination={status === "idle" ? pagination : null}
                />
            </div>}
        </div>
    );
};

const MyList = ({
                    filteredItems,
                    getListItemKey,
                    renderListRow,
                    requestMoreItems,
                    pagination,
                }) => {

    return <AutoSizer>
        {({height, width}) => (
            <FixedSizeList
                width={width}
                height={height}
                itemCount={filteredItems.length}
                itemSize={110}
                overscanCount={150}
                itemData={filteredItems}
                itemKey={getListItemKey}
                onItemsRendered={({visibleStopIndex}) => {
                    if (pagination && !pagination.is_last && visibleStopIndex + 1 >= filteredItems.length) {
                        requestMoreItems();
                    }
                }}
            >
                {renderListRow}
            </FixedSizeList>)}
    </AutoSizer>
}

function getListItemKey(index, data) {
    return data[index].id;
}

function renderListRow({index, style, data}) {

    const item = data[index];

    return (
        <SubscriptionCancellationsBrowseEditorItem
            style={style}
            dateText={convertDateText(item.created_at)}
            fromText={item.user_email}
            text={item.user_text}
        />
    );
}

function convertDateText(src) {
    // 2026-09-07T09:58:15.274068+03:00
    const regex = /^(\d\d\d\d)-(\d\d)-(\d\d)T/;
    const match = regex.exec(src);
    if (!match)
        return "??.??.????";
    return `${match[3]}.${match[2]}.${match[1]}`;
}

export default SubscriptionCancellationsBrowseEditor;